<template>
  <PageTable :shipmentCode="shipmentCode" :disabled="disabled" />
</template>
<script>
import PageTable from './components/table'
export default {
  components: { PageTable },
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>
